import React from 'react';
import PropTypes from 'prop-types';

export const withCampaignUpgradeManager = (WrappedComponent) => {
  class UpgradeDialogManager extends React.PureComponent {
    constructor(props) {
      super(props);

      this.state = {
        isUpgradeDialogOpen: false,
        selectedCampaigns: [],
      };
    }

    openUpgradeDialog = (selectedItems = [], allPages = false) => {
      this.setState({
        isUpgradeDialogOpen: true,
        selectedCampaigns: allPages ? [{ Id: -1 }] : selectedItems,
      });
    };

    closeUpgradeDialog = () => {
      this.setState({
        isUpgradeDialogOpen: false,
      });
    };

    render() {
      const {
        i18n,
      } = this.props;

      const upgradeDialogProps = {
        toolbarDropdownText: i18n.getString(_TL_('Upgrade to Performance Max')),
        isUpgradeDialogOpen: this.state.isUpgradeDialogOpen,
        openUpgradeDialog: this.openUpgradeDialog,
        closeUpgradeDialog: this.closeUpgradeDialog,
        selectedCampaigns: this.state.selectedCampaigns,
      };

      return (
        <WrappedComponent
          {...this.props}
          campaignUpgradeProps={upgradeDialogProps}
        />
      );
    }
  }

  UpgradeDialogManager.propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func,
    }).isRequired,
  };

  return UpgradeDialogManager;
};
